import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { AppStore } from '../core';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  constructor(private readonly appStore: AppStore) {}

  /**
   * Checks if current url is a call to the api.
   * @param url current url
   */
  getOperationFromUrl(url: string): string {
    return this.appStore.env !== null
      ? url.split(`${this.appStore.env.api.version}/`)[1]
      : '';
  }

  /**
   * Adds required headers to current request. Dynamic keys are merge with static keys defined in environment file.
   * @param req current request
   */
  addHeaders(req: HttpRequest<any>): HttpRequest<any> {
    if (this.appStore.env !== null) {
      return req.clone({
        setHeaders: {
          'Reference-Operation': this.getOperationFromUrl(req.url),
          'X-IBM-Client-Id': this.appStore.env.api.xIBMClientId,
          'Origin-addr': window.location.origin,
          'Content-Type': 'application/json',
          ...this.appStore.env.appHeaders,
        },
      });
    }
    throw new Error('Env is not set.');
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // if is an api call, add required headers
    if (
      this.appStore.env !== null &&
      req.url.startsWith(this.appStore.env.api.domain)
    ) {
      return next.handle(this.addHeaders(req));
    }
    return next.handle(req);
  }
}
